import { fetchRS } from "../utils/fetchRS";

export const getMateriales = (objectBody: any) =>
  fetchRS(`${process.env.REACT_APP_API_URL}/material/all`, {
    method: "POST",
    objectBody,
  });
export const getMaterial = (id: number) =>
  fetchRS(`${process.env.REACT_APP_API_URL}/material/${id}`);

export const savetMaterial = (objectBody: any) =>
  fetchRS(`${process.env.REACT_APP_API_URL}/material/`, {
    method: "PUT",
    objectBody,
  });

  export const getProductos = () =>
    fetchRS(`${process.env.REACT_APP_API_URL}/material/`);

// solicitudes de recetas

  export const getRecetas = (objectBody: any) =>
    fetchRS(`${process.env.REACT_APP_API_URL}/receta/all`, {
      method: "POST",
      objectBody,
    });
  export const getReceta = (id: number) =>
    fetchRS(`${process.env.REACT_APP_API_URL}/receta/${id}`);
  
  export const savetReceta = (objectBody: any) =>
    fetchRS(`${process.env.REACT_APP_API_URL}/receta/`, {
      method: "PUT",
      body: JSON.stringify(objectBody),
    });
  

    export const getRecetasRegistro = () =>
      fetchRS(`${process.env.REACT_APP_API_URL}/fabrica/`);


    export const getMaterialesByRecetaIds = (recetaIds: number[]) =>
      fetchRS(`${process.env.REACT_APP_API_URL}/fabrica/filterMate`, {
        method: "POST",
        // headers: {
        //   "Content-Type": "application/json"
        // },
        body: JSON.stringify({ recetaIds })
      });

      export const getRecetasByMaterialIds = (materialIds: number[]) =>
        fetchRS(`${process.env.REACT_APP_API_URL}/fabrica/filterRecet`, {
          method: "POST",
          // headers: {
          //   "Content-Type": "application/json"
          // },
          body: JSON.stringify({ materialIds })
        });
  
    // solicitudes de Fabricaciones

  export const getFabricaciones = (objectBody: any) =>
    fetchRS(`${process.env.REACT_APP_API_URL}/fabrica/all`, {
      method: "POST",
      objectBody,
    });
  export const getFabricacion = (id: number) =>
    fetchRS(`${process.env.REACT_APP_API_URL}/fabrica/${id}`);
  
  export const savetFabricacion = (objectBody: any) =>
    fetchRS(`${process.env.REACT_APP_API_URL}/fabrica/`, {
      method: "PUT",
      body: JSON.stringify(objectBody),
    });
  

   
     
  
    